<div>
  <h2 matDialogTitle class="m-b-5"> Calendarios </h2>

  <div class="widget d-flex">
    <mat-form-field class="w-40-p m-r-15" floatLabel="always">
      <mat-label>Médico</mat-label>

      <mat-select panelClass="cus-search-select" (selectionChange)="refreshCalendar($event)" [(value)]="SelectedMedico">
        
        <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
        (input)="SearchDoctors()" />
        <div class="search-options">
          <mat-option *ngFor="let option of _medicoList" [value]="option.value">
            {{option.viewValue}}
          </mat-option>
        </div>           
        
       
      </mat-select>

    </mat-form-field>
    <div class="menuSelectOption w-40-p" floatLabel="always">
      <mat-label >Empresa</mat-label>
      <!-- ORIGIN IS 0 FOR THE TREE VIEW THAT IS IN THE HEADER -->
      <app-tree-view-new [companyName]="companyName" [companyId]="this.InputData.RequestParam.empresaId" [origin]="1"  (companyNode)="onChangeCompany($event)"></app-tree-view-new>
    </div>
  </div>

  <div *ngIf="IsLoading" class="m-auto">
    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </div>

  <div *ngIf="HasService && !IsLoading" class="calendar-popup">
    <app-scheduler-calendar [DisableEventClick]="disableEventClick" [DisableDayClick]="disableDayClick"
      [Selectable]="selectable" (selectedCalendarInfo)="OnCalendarTimeSlotSelect($event)"></app-scheduler-calendar>
  </div>

  <div *ngIf="!HasService && !IsLoading">
    <p>No existen horarios de SME</p>
  </div>
</div>

<div class="text-a-r p-t-15">
  <button mat-raised-button color="accent" class="m-r-15" (click)="ConfirmDateAndTime()">Aceptar</button>
  <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>